/**
 * Web Share helpers. Used to share files (e.g. payslips) or links through the
 * native share sheet on supported devices. Returns false when sharing isn't
 * available so callers can fall back to a download.
 */
export function canShareFiles(file?: File): boolean {
  try {
    const nav = navigator as Navigator & { canShare?: (data?: ShareData) => boolean };
    if (!nav.share || !nav.canShare) return false;
    return file ? nav.canShare({ files: [file] }) : true;
  } catch {
    return false;
  }
}

export async function shareFile(
  file: File,
  opts?: { title?: string; text?: string },
): Promise<boolean> {
  try {
    const nav = navigator as Navigator & { canShare?: (data?: ShareData) => boolean };
    if (nav.share && nav.canShare?.({ files: [file] })) {
      await nav.share({ files: [file], title: opts?.title, text: opts?.text });
      return true;
    }
  } catch (err) {
    // User dismissed the share sheet — treat as handled, don't fall back.
    if (err instanceof Error && err.name === "AbortError") return true;
  }
  return false;
}
